import * as React from "react";
import { loader } from "graphql.macro";
import {
  ScheduledTournamentGetUsersToInviteQuery,
  ScheduledTournamentGetUsersToInviteQueryVariables,
} from "./graphql/ScheduledTournamentGetUsersToInvite.generated";
import { useQuery } from "../../../hooks/useQuery";
import { REFETCH_PLAYER_INVITES_INTERVAL } from "../../../config";
import { ScheduledTournamentInvitePlayersModal } from "./ScheduledTournamentInvitePlayersModal";

const GET_USERS_TO_INVITE_QUERY = loader(
  "./graphql/ScheduledTournamentGetUsersToInvite.graphql"
);

export const ScheduledTournamentInvitePlayers = ({
  tournamentId,
  onClose,
  onShowInviteMessage,
}: {
  tournamentId: string;
  onClose: () => void;
  onShowInviteMessage: () => void;
}) => {
  const [{ data }] = useQuery<
    ScheduledTournamentGetUsersToInviteQuery,
    ScheduledTournamentGetUsersToInviteQueryVariables
  >({
    query: GET_USERS_TO_INVITE_QUERY,
    variables: {
      tournamentId: tournamentId,
    },
    pollInterval: REFETCH_PLAYER_INVITES_INTERVAL,
    requestPolicy: "network-only",
  });

  return (
    <ScheduledTournamentInvitePlayersModal
      players={data?.scheduledTournamentGetUsersToInvite || []}
      tournamentId={tournamentId}
      exclude={[]}
      onClose={onClose}
      onShowInviteMessage={onShowInviteMessage}
    />
  );
};
